import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { serieProposalItemActions } from './serie-proposal-item.actions'
import { of } from 'rxjs'
import { concatMap, catchError, map } from 'rxjs/operators'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'
import { SerieProposalItem } from './serie-proposal-item'
import { SerieProposalItemService } from './serie-proposal-item.service'
import * as fromSerieProposalItem from './serie-proposal-item.reducer'

@Injectable()
export class SerieProposalItemEffects extends ResourceEffects<SerieProposalItem> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public serieProposalItemService: SerieProposalItemService,
    public router: Router
  ) {
    super(
      fromSerieProposalItem.FEATURE_NAME,
      serieProposalItemService,
      serieProposalItemActions,
      actions$
    )
  }

  updateManyByParams = createEffect(() =>
    this.actions$.pipe(
      ofType(serieProposalItemActions.updateManyByParams),
      concatMap((action) =>
        this.serieProposalItemService
          .updateManyByParams(action.updateParams)
          .pipe(
            map((serieProposalItems) =>
              normalizationActions.upsertMany({
                entities: normalizeToSchema({ serieProposalItems })
              })
            ),
            catchError(() =>
              of(serieProposalItemActions.setLoading({ isLoading: false }))
            )
          )
      )
    )
  )
}
